const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import unescape from 'lodash/unescape';

import * as Constants from '.././constants';
//Import Designs
import { Typography, Grid2, Tabs, Tab } from '@mui/material';
import { fetchFrontSetting, ForgotPassword, ResendVerificationEmail } from '../actions/front_actions';

import LoginPanel from './contestants/LoginPanel.jsx';
import Register from './contestants/Register.jsx';
import ForgotForm from './contestants/ForgotForm.jsx';
import ResendVerificationEmailForm from './contestants/ResendVerificationEmailForm.jsx';

class Logincontest extends Component {
    constructor(props) {
        super(props);
        this.state = { anchorEl: '', open: '', value: 0, forget_panel: 0, verification_panel: false };
    }

    tabProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tab-${index}`,
        };
    }

    componentDidMount = () => {
        this.setState({ wait: 1 })
        this.props.fetchFrontSetting(this.props.SITE_URL);
        this.setState({ wait: 0 })
    }

    handleextClose = (event) => {
        this.closeForget();
    }

    handleChange = (event, newValue) => {
        var elemId = event.target.id;
        if (elemId == '') {
            elemId = event.target.parentNode.id;
        }
        var newValue1 = elemId.replace(/\D/g, '');
        this.setState({ value: newValue, tabindex: parseInt(newValue1) })
    }

    handleAccount = () => {
        this.setState({ value: 0 })
    }

    handleForget = () => {
        this.setState({ forget_panel: 1 })
    }

    closeForget = () => {
        this.setState({ forget_panel: 0 })
    }

    handleForgetEvent = (username) => {
        this.props.ForgotPassword(this.props.SITE_URL, username);
    }

    toggleVerificationEmail = (show) => {
        this.setState({ verification_panel: show })
    }

    handleVerificationEmail = (username) => {
        this.props.ResendVerificationEmail(this.props.SITE_URL, username);
    }

    render() {

        const { t } = this.props;
        const allprops = this.props;
        const user_can_register = this.props.short.user_can_register;
        const settings = (typeof this.props.model !== "undefined") ? this.props.model : null;
        if (settings != null) {
            const hide_account = allprops.model.settings.common.vote_hide_account;
            const globalsetting = allprops.model;
            const user_logged = allprops.short.user_logged;
            if (!user_logged) {
                return (
                    (<div>
                        {(this.state.forget_panel == 0 && this.state.verification_panel == false) &&
                            <Grid2 container className="wpvc_login_contest_shortcode">
                                <Grid2 container size={12} className="wpvc_login_popup_title">
                                    <Grid2 className="wpvc_login_panel" size={12}>
                                        <Tabs className="wpvc_login_panel_tabs" value={this.state.value} onChange={this.handleChange}>
                                            <Tab className="wpvc_login_panel_tab" label={t("login")} {...this.tabProps(0)} />
                                            {user_can_register == 1 && hide_account == 'off' &&
                                                <Tab className="wpvc_login_panel_tab" label={t("create_account")} {...this.tabProps(1)} />
                                            }
                                        </Tabs>
                                    </Grid2>
                                </Grid2>

                                <Grid2 container className="wpvc_login_popup_content">
                                    <Grid2 size={12}>

                                        {this.state.value == 0 && <form><LoginPanel shortcode="login" SITE_URL={this.props.SITE_URL}
                                            ORIGINAL_URL={this.props.ORIGINAL_URL} constant={Constants} {...this.props.model} handleforgot={this.handleForget} handleVerificationEmail={this.toggleVerificationEmail} /></form>}

                                        {this.state.value == 1 && <form><Register shortcode="login" SITE_URL={this.props.SITE_URL} {...globalsetting} handleaccount={this.handleAccount} /></form>}

                                    </Grid2>
                                </Grid2>
                            </Grid2>
                        }
                        {this.state.forget_panel == 1 &&
                            <Grid2 container className="wpvc_login_contest_shortcode">
                                <Grid2 container size={12} className="wpvc_login_popup_title" alignItems="center">
                                    <Grid2 className="wpvc_login_panel" justifyContent="center" size={12}>
                                        <Typography className="wpvc_forget_title" variant="h6">{t('forgot_details')}</Typography>
                                    </Grid2>
                                </Grid2>
                                <Grid2 container size={12} className="wpvc_login_popup_content">
                                    <ForgotForm {...allprops} handleForgetEvent={this.handleForgetEvent} closeforgot={this.closeForget} />
                                </Grid2>
                            </Grid2>
                        }
                        {this.state.verification_panel == 1 &&

                            <Grid2 container className="wpvc_login_contest_shortcode">
                                <Grid2 container size={12} className="wpvc_login_popup_title" alignItems="center">
                                    <Grid2 className="wpvc_login_panel" justifyContent="center" size={12}>
                                        <Typography className="wpvc_forget_title" variant="h6">{t('resend_verification_email')}</Typography>
                                    </Grid2>
                                </Grid2>
                                <Grid2 container size={12} className="wpvc_login_popup_content">
                                    <ResendVerificationEmailForm {...allprops} sendEmail={this.handleVerificationEmail} toggleVerificationEmail={this.toggleVerificationEmail} />
                                </Grid2>
                            </Grid2>
                        }
                    </div>)
                );
            } else {
                return (
                    <Typography className="user_logged_in_text">
                        {t('user_logged_in')}<a href={unescape(allprops.short.wp_user_logout)}>{t('user_logout_link')}</a>
                    </Typography>
                )
            }
        } else {
            return '';
        }

    }
}

const settingstate = state => {
    return { model: state.wpvcfrontdata };
}

export default connect(settingstate, { fetchFrontSetting, ForgotPassword, ResendVerificationEmail })(withTranslation("translations")(Logincontest));
